var render = function render(){var _vm=this,_c=_vm._self._c;return _c('path',{staticClass:"cls-1",attrs:{"d":"M650,670l-4,4v-3h-5v5h3l-4,4-4-4h3v-5h-5v3l-4-4,4-4v3h5v-5h-3l4-4,4,4h-3v5h5v-3Z","transform":"translate(-630 -660)"}})
}
var staticRenderFns = []

export { render, staticRenderFns }